import { useCallback } from 'react';
import { ContactCaptureOfferRouteState } from 'src/modules/campaigns/types';
import { Campaign, CampaignConfigType, CampaignStatus } from '../types';

/**
 * After a join campaign becomes active on the full-page builder, the save lands on Campaigns like
 * any other and carries this state, so that page offers a contact capture that signs visitors up
 * to it.
 */
export const useContactCaptureOffer = (
  campaignType: CampaignConfigType,
  previousStatus: CampaignStatus | undefined,
) => {
  return useCallback((saved: Campaign): ContactCaptureOfferRouteState | undefined => {
    // The builder's own config says what was saved; the save response may omit the type.
    const newlyActiveJoin = campaignType === 'join' && saved.status === 'active' && previousStatus !== 'active';
    if (!newlyActiveJoin) return undefined;
    return { contactCaptureOffer: { campaignId: saved.id, campaignName: saved.name } };
  }, [campaignType, previousStatus]);
};
